/**
 * ThreadLifecycleRow — the centered system row for a thread event (PR-5,
 * 2026-09-09): "Miles renamed the thread from “A” to “B”", "You added
 * Justin", "Malaika removed Prest0n from the thread". Chrome, not content:
 * no bubble, no sender chip, no reactions, no seen-by, no copy button.
 */
import React from 'react';
import styled from 'styled-components';

const LifecycleRowWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 6px 12px;
`;

const LifecycleRowText = styled.span`
  max-width: 82%;
  text-align: center;
  color: var(--brand-text-secondary);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 11.5px;
  line-height: 1.4;
  letter-spacing: 0.01em;
  opacity: 0.85;
`;

export interface ThreadLifecycleRowProps {
  line: string;
  /** The event type (stable test/style hook). */
  kind: string;
  /** Optional local time label shown in the tooltip. */
  timeLabel?: string;
}

export const ThreadLifecycleRow: React.FC<ThreadLifecycleRowProps> = ({ line, kind, timeLabel }) => (
  <LifecycleRowWrap data-lifecycle-row={kind} role="status" title={timeLabel || undefined}>
    <LifecycleRowText>{line}</LifecycleRowText>
  </LifecycleRowWrap>
);

export default ThreadLifecycleRow;
